import { useEffect } from "react";
import { motion } from "framer-motion";

const framerSidebarBackground = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { delay: 0.1 } },
  transition: { duration: 0.3 },
};

const slideFromRightPanel = {
  initial: { x: "100%" },
  animate: { x: 0 },
  exit: { x: "100%" },
  transition: { duration: 0.3 },
};

const slideFromLeftPanel = {
  initial: { x: "-100%" },
  animate: { x: 0 },
  exit: { x: "-100%" },
  transition: { duration: 0.3 },
};

export function SideModal({
  onClose,
  className = "",
  overlayClassName = "",
  children,
  slideFrom = "right",
}: {
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  children: React.ReactNode;
  slideFrom?: "left" | "right";
}) {
  const handleClose = () => {
    onClose();
  };

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "";
  };

  useEffect(() => {
    disableScroll();
    return () => enableScroll();
  }, []);

  return (
    <>
      <motion.div
        {...framerSidebarBackground}
        className={`fixed z-[2] top-0 left-0 right-0 bottom-0 bg-black/40 ${overlayClassName}`}
        onClick={handleClose}
      />
      {/* The wrapper spans the viewport only to host the slide animation —
          it must not swallow clicks, or the overlay's click-to-dismiss is
          unreachable. Pointer events stay off on the wrapper and back on
          for the panel itself (its direct children). */}
      <motion.div
        {...(slideFrom === "left" ? slideFromLeftPanel : slideFromRightPanel)}
        className={`fixed z-[3] top-0 h-[100vh] left-0 right-0 flex justify-end pointer-events-none [&>*]:pointer-events-auto ${className}`}
      >
        {children}
      </motion.div>
    </>
  );
}
